import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["amountSection", "toggle"]

  connect() {
    this.updateAmountSection()
  }

  toggle() {
    this.updateAmountSection()
  }

  updateAmountSection() {
    const enabled = this.toggleTarget.checked
    if (enabled) {
      this.amountSectionTarget.classList.remove("opacity-50", "pointer-events-none")
    } else {
      this.amountSectionTarget.classList.add("opacity-50", "pointer-events-none")
    }
  }
}
